import * as yup from 'yup';
import NewAccountFormEntry from '../models/NewAccountFormEntry';
import FormError from '../../../models/FormError';

export default class FormValidationService {

    public translatedErrorMessages : any;

    private nationalSecurityNumberRegex: RegExp = /^([0-9]{2})\.(0[1-9]|1[0-2])\.(0[1-9]|[12]\d|3[01])\-([0-9]{3})\.([0-9]{2})$/;

    private validationSchema: yup.ObjectSchema = yup.object().shape({
        
        firstname: yup.string().required("required_field").max(500, "field_to_long"),
        lastname: yup.string().required("required_field").max(500, "field_to_long"),
        email: yup.string().required("required_field").email("invalid_email"),
        fileNumber: yup.string().required("required_field"),
        
        consent: yup.bool().oneOf([true], 'consent_not_given'),
        files: yup.array().min(1, 'required_field'),
    });

    public async validateProperty(values: NewAccountFormEntry, isNewCustomer: boolean, propertyName: string): Promise<FormError[]> {
        let errors: FormError[] = [];
        try {
            await this.validationSchema.validateSyncAt(propertyName, values, { abortEarly: false, context: { isCustomer: !isNewCustomer }  });
        }
        catch (err) {
            if (err.errors.length > 0) {
                errors = [new FormError("subject", [this.translatedErrorMessages[err.errors[0]]])];
            }
        }

        return errors;
    }

    public async validate(values: NewAccountFormEntry, isNewCustomer: boolean): Promise<FormError[]> {
        let errors: FormError[] = [];

        try {
            await this.validationSchema.validateSync(values, { abortEarly: false, context: { isCustomer: !isNewCustomer } });
        }
        catch (err) {
            errors = this.getFormErrorsFromValidationError(err);
        }
        return errors;
    }

    private getFormErrorsFromValidationError(validationError: any, formErrors?: FormError[]): FormError[] {
        formErrors = formErrors ?? [];
        if (validationError) {
            if (validationError.path) {
                if (formErrors.filter(err => { return err.field === validationError.path }).length === 0) {
                    const translatedMessage = this.translatedErrorMessages[validationError.message];
                    formErrors.push(new FormError(validationError.path, [translatedMessage]));
                }
            }

            if (validationError.inner && validationError.inner.length > 0) {
                for (let innerError of validationError.inner) {
                    this.getFormErrorsFromValidationError(innerError, formErrors);
                }
            }
        }
        return formErrors;
    }
}